/**
 * testing operations
 * 
 * @author    Maurizio Tidei
 * @copyright © 2019 contexagon GmbH
 */


import {REST_CALL_LOAD_OBJECT, REST_CALL_SAVE_OBJECT, REST_SERVER_BASE_URL} from "../config";
import {showError} from "./message";
import {fetchJSONActivity} from "./communication";
import {updateTestStats} from "../redux/testing/actions";


export function startStresstest() {

    return async (dispatch, getState) => {

        try {

            const { authorization } = getState();

            const id = "carnivalmisc.64246F61-EC86-4EFE-8D1B-DBB8556981D1";

            while(true) {

                // Save an Object
                let objectToSave = {"fields":{"name":"Contexagon Testobjekt"},"id":"carnivalmisc.64246F61-EC86-4EFE-8D1B-DBB8556981D1","tags":[],"timestamp-created":"2019-01-28T20:00:03.486946","timestamp-modified":"2019-01-28T20:00:03.486953","title":"Contexagon Testobjekt","type":"carnivalmisc","user-created":"info@contexagon.com"};
                const jsonSaveResponse = await fetchJSONActivity(dispatch, "saving object",
                    REST_SERVER_BASE_URL + REST_CALL_SAVE_OBJECT.path, {
                        method: REST_CALL_SAVE_OBJECT.method,
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + authorization.accessToken
                        },
                        body: JSON.stringify(objectToSave)
                    }
                );

                let savedObject = jsonSaveResponse.data;
                console.log("saved object:", savedObject);
                dispatch(updateTestStats(1));


                // Load an Object
                const json = await fetchJSONActivity(dispatch, "loading object",
                    REST_SERVER_BASE_URL + REST_CALL_LOAD_OBJECT.path.replace("<id>", id), {
                        method: REST_CALL_LOAD_OBJECT.method,
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + authorization.accessToken
                        }
                    }
                );

                let loadedObject = json.data;
                console.log("loaded object:", loadedObject);

                dispatch(updateTestStats(1));


                // Mobile REST Call
                let beaconId = "32fe8701-8b7d-2e59-76ad-91b2f62c805a-2001-11"; // Beacon Fenster

                let visitorType = "vtype";
                let mobileId = "mobile1";
                let triggerBeaconPath = `/trigger/beacon/${beaconId}?visitortype=${visitorType}&mobileid=${mobileId}`;
                const jsonBeaconResponse = await fetchJSONActivity(dispatch, "triggering beacon",
                    REST_SERVER_BASE_URL + triggerBeaconPath, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + authorization.accessToken
                        },
                        body: JSON.stringify(objectToSave)
                    }
                );

                savedObject = jsonSaveResponse.data;
                console.log("saved object:", savedObject);
                console.log("beacon response:", jsonBeaconResponse)

                dispatch(updateTestStats(1));

                // Repeat
            }

        }
        catch (error) {
            showError(error)(dispatch);
        }
    }
}
